// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
//import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDgW4DXyvfs8zHYhwCZbrTtQuZQmgFx1t4",
  authDomain: "saybic-innovation.firebaseapp.com",
  projectId: "saybic-innovation",
  storageBucket: "saybic-innovation.firebasestorage.app",
  messagingSenderId: "282720329602",
  appId: "1:282720329602:web:97ae161d96029ea92bb99b"
  //measurementId: "G-8SE1XGEQMM"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
//const analytics = getAnalytics(app);
const auth = getAuth(app); // ✅ Aquí defines auth

export { auth }; // ✅ Y aquí lo exportas
